module.exports = __webpack_public_path__ + "static/media/cirlce-360.0226517c.svg";